import { getObjectKeysAsObject } from "@checkout/helpers";
import {
  fetchAdditionalPointsPurchaseService,
  fetchAdditionalPointsPurchaseServiceConditional,
} from "./fetchAdditionalPointsPurchase";

export const RewardsServices = {
  fetchAdditionalPointsPurchaseService,
  fetchAdditionalPointsPurchaseServiceConditional,
};

export const RewardsServiceTypes = getObjectKeysAsObject(RewardsServices);
